import type { HyperlinkInterface } from '@hypercodestudio/basler-components';
import type { LocationQueryRaw, LocationQueryValueRaw } from 'vue-router';

function isQueryValue(value: unknown): value is LocationQueryValueRaw {
  return (
    value == null || typeof value === 'string' || typeof value === 'number'
  );
}

/** Read a filter link's route query without treating URL strings as route objects. */
export function getHyperlinkQuery(
  link: HyperlinkInterface | undefined
): LocationQueryRaw | undefined {
  const uri = link?.uri;
  if (!uri || typeof uri !== 'object' || !('query' in uri)) {
    return undefined;
  }
  const query = uri.query;
  if (!query || typeof query !== 'object' || Array.isArray(query)) {
    return undefined;
  }

  const entries: Array<
    [string, LocationQueryValueRaw | LocationQueryValueRaw[]]
  > = [];
  for (const [key, value] of Object.entries(query)) {
    if (
      isQueryValue(value) ||
      (Array.isArray(value) && value.every(isQueryValue))
    ) {
      entries.push([key, value]);
    } else {
      return undefined;
    }
  }
  return Object.fromEntries(entries);
}
